module.exports = __webpack_public_path__ + "media/images/page/top/top_img_01-0f77cb2e85cf2b02a84ca34fc71de505.png";